/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsBudgetSystem extends models.RecommendationBaseForFinOps {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsBudgetSystem");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsBudgetSystem.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsBudgetSystem>): RecommendationForFinopsBudgetSystem {
        let obj = Object.assign(new RecommendationForFinopsBudgetSystem(), model);
        RecommendationForFinopsBudgetSystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsBudgetSystem>): RecommendationForFinopsBudgetSystem {
        if (!model) return null;
        return RecommendationForFinopsBudgetSystem.newInstance(<RecommendationForFinopsBudgetSystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsBudgetSystem) {
        if (!obj) return;

        models.RecommendationForFinopsBudgetSystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsBudgetSystem): boolean {
        if (models.RecommendationBaseForFinOps.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsBudgetSystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
